import get from 'lodash/get'
import {createSelector} from 'reselect'

import {status} from './helpers'
import {MEASURED_AT_LOCATIONS} from '../const'
import FitProfile, {EMPTY_FIT_PROFILE} from '../types/FitProfile'
import {and, notFn} from '../utils'

// Get

export const fitProfile = (state) => get(state, 'fitProfile.data')

// Status

export const {isFailure, isPending, isSuccess} = status('fitProfile')

// Computed

export const exist = createSelector(
  fitProfile,
  ($fitProfile) => $fitProfile instanceof FitProfile && $fitProfile !== EMPTY_FIT_PROFILE,
)

export const isFatal = createSelector(notFn(fitProfile), isFailure, and)

export const hasMeasuredAt = createSelector(
  fitProfile,
  exist,
  ($fitProfile, $exist) => $exist && $fitProfile.measuredAt != null,
)

export const flowName = createSelector(
  fitProfile,
  exist,
  hasMeasuredAt,
  ($fitProfile, $exist, $hasMeasuredAt) => {
    if (!$exist) {
      return null
    }

    if ($hasMeasuredAt) {
      return Object.keys(MEASURED_AT_LOCATIONS).find(
        (key) => MEASURED_AT_LOCATIONS[key] === $fitProfile.measuredAt,
      )
    }

    // If measuredAt is null but the fitProfile exists, then the user went through the Fit Survey
    return 'Fit Survey'
  },
)
